import { apiGet, apiPost } from './api';
import API_CONFIG from '../config/api';

export const getPresidenteMe = async () => {
  const response = await apiGet(API_CONFIG.ENDPOINTS.PRESIDENTE_CLUB.ME);
  const data = await response.json();
  if (!data.success) throw new Error(data.error || 'Error al obtener club del presidente');
  return data.data;
};

export const listarUsuariosPresidente = async ({ page = 1, limit = 20, search = '' } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('search', search);

  const url = `${API_CONFIG.ENDPOINTS.PRESIDENTE_CLUB.LISTAR_USUARIOS}?${params.toString()}`;
  const response = await apiGet(url);
  const data = await response.json();
  if (!data.success) throw new Error(data.error || 'Error al listar usuarios');
  return data;
};

export const asociarUsuarioAPresidente = async (rut) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.PRESIDENTE_CLUB.ASOCIAR_USUARIO(rut), {});
  const data = await response.json();
  if (!data.success) throw new Error(data.error || 'Error al asociar usuario');
  return data;
};

export const quitarUsuarioDePresidente = async (rut) => {
  const response = await apiPost(API_CONFIG.ENDPOINTS.PRESIDENTE_CLUB.QUITAR_USUARIO(rut), {});
  const data = await response.json();
  if (!data.success) throw new Error(data.error || 'Error al quitar asociación');
  return data;
};

